import React from 'react'

const NoRecordsAddButtonLayout = ({ children }) => {
    return (
        <div className="inline-flex mt-4">
            {children}
        </div>
    )
}

export default NoRecordsAddButtonLayout